<template>
	<ShaderCanvas>
		<div ref="el" data-component="error">
			<div class="content">
				<h2 class="-title-1">True ownership not found?</h2>
				<ButtonSimple label="Back to Home" :link="{ type: 'internal', url: '/' }" />
			</div>

			<div class="shader-container" data-shader="gold-header">
				<div class="corner-overlay top-left"></div>
				<div class="corner-overlay top-right"></div>
				<div class="corner-overlay bottom-left"></div>
				<div class="corner-overlay bottom-right"></div>
			</div>
		</div>
	</ShaderCanvas>
</template>

<script setup>
import { gsap, CustomEase } from 'gsap/all'
import SplitText from 'gsap/SplitText'

import { ShaderCanvas } from '~/components/primitives'
import { ButtonSimple } from '~/components/primitives'

const props = defineProps({})

import.meta.client && gsap.registerPlugin(SplitText, CustomEase)

const el = ref(null)

const context = inject('pageContext')

let split = null

const setup = () => {
	const titleEl = el.value.querySelector('h2')

	if (titleEl) {
		split = new SplitText(titleEl, { type: 'words', wordsClass: 'word-target' })

		split.words.forEach((word) => {
			const wrapper = document.createElement('span')
			wrapper.classList.add('word-mask')
			wrapper.style.display = 'inline-block'
			wrapper.style.overflow = 'hidden'
			wrapper.style.verticalAlign = 'bottom' // Matches Header.vue

			wrapper.style.paddingBottom = '5px'
			wrapper.style.marginBottom = '-5px'
			wrapper.style.paddingRight = '5px'
			wrapper.style.marginRight = '-5px'

			word.parentNode.insertBefore(wrapper, word)
			wrapper.appendChild(word)

			const space = document.createTextNode(' ')
			wrapper.parentNode.insertBefore(space, wrapper.nextSibling)
		})

		init()
	}
}

const init = () => {
	if (split && split.words) {
		gsap.fromTo(
			split.words,
			{
				y: '105%',
			},
			{
				y: '0%',
				stagger: 0.07,
				duration: 0.9,
				ease: CustomEase.create('custom', 'M0,0 C0.7,0 0,1 1,1 '),
				delay: 0.2,
			}
		)
	}

	if (el.value.querySelector('button')) {
		gsap.fromTo(
			el.value.querySelector('button'),
			{
				y: 10,
				opacity: 0,
			},
			{
				opacity: 1,
				y: 0,
				duration: 1.5,
				ease: 'expo.out',
				delay: 1.2,
			}
		)
	}
}

const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {
	context.$page.loader.ready.then(() => setup())
})
</script>

<style lang="scss" scoped>
[data-component='error'] {
	position: relative;
	height: 100vh;

	.content {
		position: absolute;

		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		text-align: center;

		z-index: 1;

		display: flex;
		flex-direction: column;
		align-items: center;

		gap: rs(32);

		width: column-width(14);
	}

	.shader-container {
		position: absolute;

		top: rs(24, 24);
		left: rs(24, 24);
		right: rs(24, 24);
		bottom: rs(24, 24);

		@include max-width($sm) {
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
		}

		.corner-overlay {
			position: absolute;
			width: rs(12);
			height: rs(12);

			$radius: 12px;
			$color: var(--color-geral-brown);

			@if $radius == 12px {
				$radius: 70.8%;
			}

			&.top-left {
				top: -1px;
				left: -1px;
				background: radial-gradient(circle at 100% 100%, transparent $radius, $color $radius);
			}

			&.top-right {
				top: -1px;
				right: -1px;
				background: radial-gradient(circle at 0% 100%, transparent $radius, $color $radius);
			}

			&.bottom-left {
				bottom: -1px;
				left: -1px;
				background: radial-gradient(circle at 100% 0%, transparent $radius, $color $radius);
			}

			&.bottom-right {
				bottom: -1px;
				right: -1px;
				background: radial-gradient(circle at 0% 0%, transparent $radius, $color $radius);
			}
		}
	}
}
</style>
